var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "groupControl"
  }, [_c("div", {
    staticClass: "card_box",
    class: {
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.toggleSelection(_vm.index, _vm.item);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.controlName)))]), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.item.controlExplain)) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), !_vm.item.control || _vm.item.control.length === 0 ? _c("div", {
    staticClass: "blankBox"
  }, [_vm._v(" " + _vm._s(_vm.item.blankTxt) + " ")]) : _vm._l(_vm.item.control, function (group, idx) {
    return _c("div", {
      key: idx,
      ref: "groupItem",
      refInFor: true,
      staticClass: "groupFormBox"
    }, [_c("groupControlItem", {
      attrs: {
        groupItem: group,
        index: idx,
        groupFormData: _vm.item.control
      }
    })], 1);
  })], 2), _vm.item.isCheck ? [_c("control-action", {
    attrs: {
      isGroupControl: true,
      "current-control-item": _vm.item,
      formDataArray: _vm.formDataArray,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? _c("div", [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        return _vm.formeClose(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };